import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "timerDiv pa-5 bg-tertiary d-flex",
  style: {"justify-content":"center","align-items":"center"}
}
const _hoisted_2 = {
  key: 0,
  id: "timerOverflowDiv"
}
const _hoisted_3 = {
  key: 1,
  style: {"width":"60%"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", null, "Submit", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", null, "Change button mode", -1)

import { ref, watch } from "vue";
import formatNormal from "@/js/timeFormat";
type Time = {
    id: number;
    str: string;
    num: number;
    added2: boolean;
    addedDnf: boolean;
    scramble: string;
    date: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Timer',
  props: ["removeTime", "currTheme", "editingOptions", "showTimeList", "timeList", "currentScramble"],
  emits: ["time-done", "timer-running"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
//* vars
let changeModeBtn: null | HTMLButtonElement = null;

window.document.addEventListener("load", () => {
    changeModeBtn = document.getElementById("changeMode") as HTMLButtonElement;
});

const jscookie = require("js-cookie");
let currentTimeStr = ref<string>("0.00");
let currentTime = ref<number>(0);
let startOfTimer: number | null = null;
let timerRunning: boolean = false;
let intervalTimer: undefined | number;
let spaceDown = ref<boolean>(false);
let lightTheme = ref<boolean>(false);
let timerMode = ref<"normal" | "input">("normal");
let timeInInput = ref<string>("");
let screenWidth = ref<number>(window.screen.width);
let fontSize = 128;

//* change state of timer
function manageTimer() {
    resetFontSize();
    changeOverflowFontSize();
    if (!(!props.editingOptions && timerMode.value == "normal" && !props.showTimeList)) return;

    if (!timerRunning) {
        //* start timer if its not running
        startOfTimer = new Date().getTime();
        intervalTimer = setInterval(() => {
            currentTime.value = new Date().getTime() - startOfTimer!;
            currentTimeStr.value = formatNormal(Math.trunc(currentTime.value / 10).toString());
            changeOverflowFontSize();
        }, 10);
        timerRunning = true;
    } else if (timerRunning) {
        //* stop timer if its running
        clearInterval(intervalTimer);
        currentTime.value = Math.trunc((new Date().getTime() - startOfTimer!) / 10);
        currentTimeStr.value = formatNormal(currentTime.value.toString());
        timerRunning = false;
        const time = {
            id: 0,
            str: currentTimeStr.value,
            num: currentTime.value,
            added2: false,
            addedDnf: false,
            scramble: props.currentScramble,
            date: Number(new Date()),
        };

        if (time.num === 0) return;

        //* send the time to TimeList
        emit("time-done", time);
    }
    emit("timer-running", timerRunning);
}

//* turn on the timer when space is pressed
document.body.addEventListener("keyup", (e) => {
    spaceDown.value = false;
    if (e.key == "m" && e.ctrlKey) {
        timerMode.value = timerMode.value == "normal" ? "input" : "normal";
        return;
    }

    if (timerMode.value == "normal") {
        if (timerRunning && e.code != "Space" && e.code != "Escape") {
            manageTimer();
        }

        if (e.code == "Space") {
            manageTimer();
        }

        if (e.code == "Escape" && timerRunning) {
            clearInterval(intervalTimer);
            timerRunning = false;
            currentTime.value = 0;
            currentTimeStr.value = "0.00";
            emit("timer-running", timerRunning);
        }
    } else if (timerMode.value == "input") {
        if (e.key == "Enter") {
            submitInputTime();
        }
    }
});

function submitInputTime() {
    let value: string = timeInInput.value.replace(/\D/g, "");
    value = value.length <= 6 ? value : value.slice(0, 6);
    if (value.length && value.match(/[1-9]+/)) {
        const time = {
            id: Number(props.timeList.length),
            str: formatNormal(value, "addDots"),
            num: Number(formatNormal(value, "calcNumBasedStr")),
            added2: false,
            addedDnf: false,
            scramble: props.currentScramble,
            date: Number(new Date()),
        };
        emit("time-done", time);
    }
    timeInInput.value = "";
}

function checkOverflow(element: HTMLElement) {
    var curOverflow = element.style.overflow;

    if (!curOverflow || curOverflow === "visible") element.style.overflow = "hidden";

    var isOverflowing = element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;

    element.style.overflow = curOverflow;

    return isOverflowing;
}

function resetFontSize() {
    fontSize = 128;
    document.getElementById("timerText")!.style.fontSize = `${fontSize}px`;
}

function changeOverflowFontSize() {
    if (timerMode.value == "normal") {
        const timerText = document.getElementById("timerText")!;
        const timerOverflowDiv = document.getElementById("timerOverflowDiv")!;

        let overflow = checkOverflow(timerOverflowDiv);

        if (overflow) {
            fontSize--;
            timerText.style.fontSize = `${fontSize}px`;
            changeOverflowFontSize();
        }
    }
}

document.body.addEventListener("keydown", (e) => {
    if (e.code == "Space" && !timerRunning) {
        spaceDown.value = true;
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: {},
      class: "d-flex timerContainer",
      onTouchend: _cache[2] || (_cache[2] = ($event: any) => (_unref(screenWidth) <= 600 ? manageTimer() : null))
    }, [
      (_unref(timerMode) == 'normal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", {
              class: _normalizeClass({
                        'text-amber': _unref(spaceDown),
                        'text-black': _ctx.$props.currTheme === 'light',
                        'text-amber-lighten-1': _unref(spaceDown) && _ctx.$props.currTheme === 'amber',
                    }),
              id: "timerText",
              style: {"user-select":"none","font-size":"128px"}
            }, _toDisplayString(_unref(currentTimeStr)), 3)
          ]))
        : (_unref(timerMode) == 'input')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_text_field, {
                class: "timeInput",
                "hide-details": "auto",
                label: "Input your time",
                modelValue: _unref(timeInInput),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(timeInInput) ? (timeInInput).value = $event : timeInInput = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_btn, {
                style: {"width":"100%"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (submitInputTime())),
                color: "background"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
    ], 32),
    _createVNode(_component_v_btn, {
      style: {"position":"absolute","bottom":"0","right":"0"},
      onClick: _cache[3] || (_cache[3] = ($event: any) => {
                _unref(timerMode) == 'input' ? (_isRef(timerMode) //@ts-ignore
 ? timerMode.value = 'normal' : timerMode = 'normal') : (_isRef(timerMode) //@ts-ignore
 ? timerMode.value = 'input' : timerMode = 'input');
                ($event.target as HTMLButtonElement).blur();
            }),
      id: "changeMode",
      color: "background"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    })
  ]))
}
}

})